import { d as s, _ as o } from "./_plugin-vue_export-helper-8568c831.mjs";
import { openBlock as t, createElementBlock as n, normalizeClass as c, normalizeStyle as r, createElementVNode as l } from "vue";
const a = s("ask"), i = /* @__PURE__ */ l("path", {
  d: "M512 1024C230.4 1024 0 793.6 0 512S230.4 0 512 0s512 230.4 512 512-230.4 512-512 512zm0-938.667c-234.667 0-426.667 192-426.667 426.667s192 426.667 426.667 426.667 426.667-192 426.667-426.667S746.667 85.333 512 85.333zm0 529.067c-25.6 0-42.667-17.067-42.667-42.667v-38.4c0-29.866 21.334-59.733 55.467-64 8.533 0 12.8-4.266 12.8-4.266 25.6-8.534 38.4-34.134 38.4-59.734 0-34.133-29.867-64-64-64s-64 29.867-64 64c0 25.6-17.067 42.667-42.667 42.667s-42.666-17.067-42.666-42.667C362.667 324.267 430.933 256 512 256s149.333 68.267 149.333 149.333c0 59.734-38.4 115.2-93.866 136.534-4.267 0-8.534 4.266-12.8 4.266v21.334c0 25.6-17.067 46.933-42.667 46.933zm-64 110.933a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z",
  fill: "currentColor",
  "fill-opacity": "0.9"
}, null, -1), m = [
  i
];
function p(e, _, d, f, u, v) {
  return t(), n("svg", {
    class: c(e.classes),
    style: r(e.style),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    role: "presentation"
  }, m, 6);
}
const z = /* @__PURE__ */ o(a, [["render", p]]);
export {
  z as default
};
